import type { Locale, PaymentMethod } from '@360face/domain';

const pt = {
  menuClassPass: 'ClassPass',
  menuClassPassSub: 'Reservei pelo ClassPass',
  cpTitle: 'Escolha a hora da sua reserva',
  cpNone: 'Não há reservas ClassPass para as próximas horas.',
  cpNotFound: 'Não encontra a sua hora?',
  cpChat: 'Se não encontra a sua marcação, escreva-nos, por favor, no chat da sua app ClassPass.',
  cpIsYou: (name: string) => `É ${name}?`,
  cpYes: 'Sim, sou eu',
  cpNo: 'Não',
  cpAddonsTitle: 'Quer acrescentar algo à sua sessão?',
  cpNoTime: 'Não cabe antes da próxima marcação',
  nifNote: '* Para fatura com NIF, indique o número ao terapeuta ou no pagamento.',
  countryTitle: 'Indicativo do país',
  countrySearch: 'Procurar país ou indicativo',
  notFoundTitle: 'Marcação não encontrada',
  notFoundText: 'Verifique o número de telemóvel e o indicativo do país.',
  notFoundAgain: 'Não encontrámos de novo. A equipa ajuda-o já.',
  tryAgain: 'Tentar outra vez',
  callAdmin: 'Chamar a equipa',
  giftPhoneTitle: 'O seu telemóvel',
  giftPhoneSub: 'Para enviarmos o comprovativo e para o caso de precisarmos de o contactar.',
  buy: 'Comprar',
  qTitle: 'Já preencheu a nossa ficha de cliente?',
  qSub: 'É obrigatória antes de qualquer tratamento.',
  qYes: 'Sim, já preenchi',
  qNo: 'Não, ainda não',
  qConfirm: 'Confirmo que já preenchi a ficha de cliente e que os meus dados de saúde não mudaram.',
  qNeeded: 'Sem problema. O seu terapeuta dá-lhe a ficha antes do tratamento.',
  qfOffer:
    'Pode preencher a ficha agora, aqui no ecrã. São algumas perguntas rápidas sobre a sua saúde (cerca de 1 minuto).',
  qfStart: 'Preencher agora',
  qfPaper: 'Prefiro a ficha em papel',
  qfYes: 'Sim',
  qfNo: 'Não',
  qfDetailHint: 'Detalhes (opcional)',
  qfName: 'Nome completo',
  qfMissing: 'Responda a todas as perguntas, indique o seu nome e dê o consentimento.',
  qfSubmit: 'Enviar ao meu terapeuta',
  qfCancel: 'Cancelar',
  qfPrivate: 'As respostas seguem de forma segura para o seu terapeuta e não ficam guardadas neste ecrã.',
  qfDraft: 'Perguntas provisórias (em aprovação).',
  qfLoadError: 'Não foi possível abrir a ficha. Escolha a ficha em papel ou chame a equipa.',
  qfStepAbout: 'Sobre si',
  qfStepHealth: 'Saúde',
  qfStepAesthetic: 'Procedimentos estéticos',
  qfStepSign: 'Confirmação',
  qfBirth: 'Data de nascimento',
  qfBirthHint: 'DD/MM/AAAA',
  qfContact: 'Como prefere ser contactada/o?',
  qfContactEmail: 'E-mail',
  qfContactWhatsapp: 'WhatsApp',
  qfContactTelegram: 'Telegram',
  qfContactPhone: 'Chamada',
  qfPressure: 'Intensidade da massagem',
  qfPressureHint:
    '1 = muito suave, 3 = média, 5 = muito intensa. Na primeira vez recomendamos 2–3. Pode ajustar durante a sessão.',
  qfSimilar: 'Já fez tratamentos semelhantes?',
  qfHeard: 'Como nos conheceu?',
  qfHeardInstagram: 'Instagram',
  qfHeardGoogle: 'Google',
  qfHeardFriend: 'Recomendação',
  qfHeardClasspass: 'ClassPass',
  qfHeardTiktok: 'TikTok',
  qfHeardAi: 'Assistente de IA (ChatGPT, Claude…)',
  qfHeardPassing: 'Passei pelo estúdio',
  qfHeardOther: 'Outro',
  qfHealthRead: 'Leia a lista com atenção:',
  qfNoneApply: 'Nada desta lista se aplica a mim',
  qfSomeApply: 'Tenho algo desta lista',
  qfTickWhich: 'Toque no que se aplica. A terapeuta vê isto só hoje.',
  qfNote: 'Comentário (opcional)',
  qfAestheticWhat: 'O quê, em que zona e quando?',
  qfSignHere: 'Assine aqui com o dedo',
  qfClear: 'Limpar',
  qfNext: 'Continuar',
  qfPrev: 'Anterior',
  qfPageMissing: 'Complete os campos assinalados.',
  menuGift: 'Comprar um certificado',
  menuGiftSub: 'Um presente pronto a levar',
  giftTitle: 'Certificado de oferta',
  giftSub: 'Escolha o valor. O certificado vale esse montante em qualquer tratamento.',
  giftHowTitle: 'Como quer receber o certificado?',
  giftPickup: 'Levantar agora no estúdio',
  giftPickupSub: 'A equipa entrega o envelope em 10–15 minutos, depois do pagamento.',
  giftEmail: 'Receber por e-mail',
  giftEmailSub: 'Enviamos o pedido à equipa; combinamos o pagamento consigo por e-mail.',
  giftEmailField: 'O seu e-mail',
  kbDone: 'Concluído',
  kbSpace: 'espaço',
  giftCardTitle: 'Para quem é o presente?',
  giftCardSub:
    'Estes dados vão no certificado. Depois de enviar, entramos em contacto por e-mail com as formas de pagamento.',
  giftTo: 'Para (nome)',
  giftFrom: 'De (o seu nome)',
  giftMessage: 'Mensagem (opcional)',
  giftSend: 'Enviar pedido',
  doneGiftEmail: (v: string) =>
    `Recebemos o seu pedido de certificado de ${v}. A nossa equipa entra em contacto por e-mail para combinar o pagamento e enviar o certificado.`,
  thanks: 'Obrigada!',
  doneGift: (v: string) => `A equipa entrega-lhe o certificado de ${v} dentro de 10–15 minutos, depois do pagamento.`,
  languageTitle: 'Escolha o idioma',
  productsTitle: 'Para casa',
  productsSub: 'Mantenha o efeito do tratamento em casa. Opcional.',
  productAdd: 'Adicionar',
  productAdded: 'Adicionado',
  productsSkip: 'Continuar sem produtos',
  productsNone: 'De momento não há produtos disponíveis.',
  summaryTotal: 'Total',
  presentTitle: 'O seu presente',
  presentSub: (amount: string) => `Com ${amount} em tratamentos, escolha um presente da casa.`,
  presentNone: 'Continuar sem presente',
  presentHint: (missing: string, gifts: string) => `Junte mais ${missing} e escolha um presente: ${gifts}`,
  presentFrom: (amount: string) => `A partir de ${amount}`,
  presentLabel: 'Presente',
  presentFree: 'Oferta',
  summaryExtras: (n: number) => (n === 1 ? '+1 extra' : `+${n} extras`),
  summaryProducts: (n: number) => (n === 1 ? '1 produto' : `${n} produtos`),
  callStaffDone: 'A equipa foi avisada. Alguém vem já ter consigo.',
  tagline: 'Treino facial com as mãos das nossas terapeutas. Sem agulhas.',
  chooseLanguage: 'Escolha o idioma para começar',
  bookThis: 'Marcar este serviço',
  sourceNote: 'Descrição e foto: 360face.pt',
  progress: ['Serviço', 'Dia e hora', 'Extras', 'Dados', 'Confirmar'],
  stepOf: (n: number, total: number) => `Passo ${n} de ${total}`,
  hourLabel: (h: string) => `${h}h`,
  welcome: 'Bem-vinda ao 360°FACE',
  welcomeSub: 'Toque para começar',
  menuTitle: 'Olá! Como podemos ajudar hoje?',
  menuBook: 'Marcar um tratamento',
  menuBookSub: 'Hoje ou noutro dia',
  menuCheckin: 'Já tenho marcação',
  menuCheckinSub: 'Fazer check-in',
  chooseService: 'O que lhe apetece hoje?',
  kinds: { face: 'Rosto', body: 'Corpo', skin: 'Pele', combo: 'Combinados', addon: 'Extras' },
  minutes: 'min',
  chooseDate: 'Escolha o dia',
  chooseTime: 'Quando lhe dá mais jeito?',
  with: 'com',
  noSlots: 'Não há horários livres neste dia. Escolha outro dia.',
  addonsTitle: 'Quer acrescentar algo?',
  addonsSub: 'Opcional. Pode continuar sem extras.',
  continue: 'Continuar',
  skip: 'Continuar sem extras',
  detailsTitle: 'Os seus dados',
  fields: {
    fullName: 'Nome e apelido',
    phone: 'Telemóvel',
    email: 'Email',
  },
  fieldErrors: {
    fullName: 'Indique o seu nome.',
    phone: 'Número de telemóvel inválido.',
    email: 'Email inválido.',
    privacy: 'É necessário aceitar para continuar.',
  },
  privacy: 'Aceito que o 360°FACE trate os meus dados para gerir a marcação.',
  marketing: 'Quero receber novidades e ofertas (opcional).',
  reviewTitle: 'Confirme a marcação',
  total: 'Total',
  confirm: 'Confirmar marcação',
  sending: 'A enviar…',
  paymentTitle: 'Como prefere pagar?',
  paymentSub: 'O pagamento é feito no fim do tratamento. Nada é cobrado agora.',
  paymentLater: 'Decidir depois',
  methods: {
    card_terminal: 'Cartão',
    mbway: 'MB WAY',
    cash: 'Numerário',
    bank_transfer: 'Transferência',
    gift_card: 'Pagar com certificado',
    qr_transfer: 'QR code',
  } satisfies Record<PaymentMethod, string>,
  doneTitle: (name: string) => `Obrigada, ${name}!`,
  doneBooked: 'A sua marcação está registada.',
  doneFuture: 'No dia da visita, toque em «Tenho marcação» neste ecrã. Nessa altura escolhe como pagar.',
  doneRequested: 'O seu pedido foi registado. A equipa confirma a marcação em breve.',
  doneCheckedIn: 'Check-in feito. Sente-se, por favor — a sua terapeuta já foi avisada.',
  doneNewCustomer: 'Até breve!',
  checkinTitle: 'Indique o seu telemóvel',
  checkinFind: 'Procurar marcação',
  scanOr: 'ou',
  scanHint: 'Aproxime o QR do seu cartão 360°FACE do leitor',
  cardNoBooking: 'Não encontrámos uma marcação para hoje com este cartão. Indique o seu telemóvel.',
  checkinMatches: 'Confirme a sua marcação de hoje',
  confirmBooking: 'Confirmo',
  checkinNone: 'Não encontrámos marcações para hoje com este número.',
  checkinBook: 'Marcar agora',
  back: 'Voltar',
  callStaff: 'Chamar a equipa',
  loading: 'A carregar…',
  newStart: 'Nova marcação',
  errors: {
    CARD_NOT_FOUND: 'Cartão não reconhecido. Indique o seu telemóvel.',
    NETWORK: 'Sem ligação à internet. Tente novamente dentro de instantes.',
    CRM_UNAVAILABLE: 'O sistema de marcações não responde. Tente novamente ou chame a equipa.',
    CRM_RATE_LIMITED: 'Muitos pedidos ao mesmo tempo. Tente novamente dentro de instantes.',
    TOO_MANY_REQUESTS: 'Muitas tentativas. Aguarde um minuto ou chame a equipa.',
    SLOT_TAKEN: 'Esta hora acabou de ser ocupada. Escolha outra, por favor.',
    RECOGNITION_EXPIRED: 'Por segurança, confirme os seus dados mais uma vez.',
    NO_TIME_FOR_ADDON: 'Hoje já não há tempo para este extra antes da próxima marcação.',
    VISIT_ALREADY_DONE: 'Esta marcação já foi concluída. Se precisar de ajuda, chame a equipa.',
    VISIT_NOT_EDITABLE: 'Esta visita já não pode ser alterada aqui. Chame a equipa, por favor.',
    BOOKING_NOT_FOUND: 'Não encontrámos esta marcação. Chame a equipa, por favor.',
    VALIDATION_FAILED: 'Verifique os dados indicados.',
    PRODUCT_UNAVAILABLE: 'Este produto já não está disponível.',
    UNKNOWN_GIFT: 'Este certificado não está disponível. Chame a equipa, por favor.',
    QUESTIONNAIRE_VERSION_MISMATCH: 'A ficha foi atualizada. Comece de novo ou chame a equipa.',
    QUESTIONNAIRE_INCOMPLETE: 'Responda a todas as perguntas.',
    default: 'Algo correu mal. Tente novamente ou chame a equipa.',
  },
  retry: 'Tentar novamente',
};

export type Messages = typeof pt;

const en: Messages = {
  menuClassPass: 'ClassPass',
  menuClassPassSub: 'I booked with ClassPass',
  cpTitle: 'Choose the time of your booking',
  cpNone: 'No ClassPass bookings in the next hours.',
  cpNotFound: 'Can’t find your time?',
  cpChat: 'If you can’t find your booking, please write to us in the chat of your ClassPass app.',
  cpIsYou: (name: string) => `Are you ${name}?`,
  cpYes: 'Yes, that’s me',
  cpNo: 'No',
  cpAddonsTitle: 'Would you like to add something to your session?',
  cpNoTime: 'Does not fit before the next booking',
  nifNote: '* For an invoice with a tax number (NIF), tell your therapist or give it when you pay.',
  countryTitle: 'Country code',
  countrySearch: 'Search country or code',
  notFoundTitle: 'Booking not found',
  notFoundText: 'Please check your mobile number and country code.',
  notFoundAgain: 'Still not found. Our team will help you right away.',
  tryAgain: 'Try again',
  callAdmin: 'Call staff',
  giftPhoneTitle: 'Your mobile number',
  giftPhoneSub: 'So we can send the receipt and contact you if needed.',
  buy: 'Buy',
  qTitle: 'Have you filled in our client form before?',
  qSub: 'It is required before any treatment.',
  qYes: 'Yes, I have',
  qNo: 'No, not yet',
  qConfirm: 'I confirm I have filled in the client form and my health details have not changed.',
  qNeeded: 'No problem. Your therapist will give you the form before the treatment.',
  qfOffer:
    'You can fill in the form now, here on the screen. A few quick questions about your health (about 1 minute).',
  qfStart: 'Fill in now',
  qfPaper: 'I prefer a paper form',
  qfYes: 'Yes',
  qfNo: 'No',
  qfDetailHint: 'Details (optional)',
  qfName: 'Full name',
  qfMissing: 'Please answer every question, enter your name and give your consent.',
  qfSubmit: 'Send to my therapist',
  qfCancel: 'Cancel',
  qfPrivate: 'Your answers go securely to your therapist and are not kept on this screen.',
  qfDraft: 'Provisional questions (pending approval).',
  qfLoadError: 'The form could not be opened. Choose the paper form or call staff.',
  qfStepAbout: 'About you',
  qfStepHealth: 'Health',
  qfStepAesthetic: 'Aesthetic procedures',
  qfStepSign: 'Confirmation',
  qfBirth: 'Date of birth',
  qfBirthHint: 'DD/MM/YYYY',
  qfContact: 'How would you like us to contact you?',
  qfContactEmail: 'E-mail',
  qfContactWhatsapp: 'WhatsApp',
  qfContactTelegram: 'Telegram',
  qfContactPhone: 'Phone call',
  qfPressure: 'Massage intensity',
  qfPressureHint:
    '1 = very soft, 3 = medium, 5 = very intense. First time? We recommend 2–3. It can be adjusted during the session.',
  qfSimilar: 'Have you had similar treatments before?',
  qfHeard: 'How did you hear about us?',
  qfHeardInstagram: 'Instagram',
  qfHeardGoogle: 'Google',
  qfHeardFriend: 'Recommendation',
  qfHeardClasspass: 'ClassPass',
  qfHeardTiktok: 'TikTok',
  qfHeardAi: 'AI assistant (ChatGPT, Claude…)',
  qfHeardPassing: 'Walked past the studio',
  qfHeardOther: 'Other',
  qfHealthRead: 'Please read the list carefully:',
  qfNoneApply: 'Nothing on this list applies to me',
  qfSomeApply: 'Something on this list applies',
  qfTickWhich: 'Tap what applies. Your therapist sees this today only.',
  qfNote: 'Comment (optional)',
  qfAestheticWhat: 'What, which area and when?',
  qfSignHere: 'Sign here with your finger',
  qfClear: 'Clear',
  qfNext: 'Continue',
  qfPrev: 'Back',
  qfPageMissing: 'Please complete the highlighted fields.',
  menuGift: 'Buy a gift card',
  menuGiftSub: 'A ready-to-take present',
  giftTitle: 'Gift card',
  giftSub: 'Choose the amount. The certificate is worth that amount on any treatment.',
  giftHowTitle: 'How would you like to receive it?',
  giftPickup: 'Pick up now in the studio',
  giftPickupSub: 'The team hands you the envelope in 10–15 minutes, after payment.',
  giftEmail: 'Receive by e-mail',
  giftEmailSub: 'We send the request to the team; we agree the payment with you by e-mail.',
  giftEmailField: 'Your e-mail',
  kbDone: 'Done',
  kbSpace: 'space',
  giftCardTitle: 'Who is the gift for?',
  giftCardSub: 'These go on the certificate. After you send, we e-mail you the payment options.',
  giftTo: 'For (name)',
  giftFrom: 'From (your name)',
  giftMessage: 'Message (optional)',
  giftSend: 'Send request',
  doneGiftEmail: (v: string) =>
    `We have your request for a ${v} certificate. Our team will e-mail you to agree the payment and send the certificate.`,
  thanks: 'Thank you!',
  doneGift: (v: string) => `The team hands you the ${v} certificate in 10–15 minutes, after payment.`,
  languageTitle: 'Choose your language',
  productsTitle: 'For home',
  productsSub: 'Keep the effect of your treatment at home. Optional.',
  productAdd: 'Add',
  productAdded: 'Added',
  productsSkip: 'Continue without products',
  productsNone: 'No products available right now.',
  summaryTotal: 'Total',
  presentTitle: 'Your gift',
  presentSub: (amount: string) => `With ${amount} in treatments, choose a gift from us.`,
  presentNone: 'Continue without a gift',
  presentHint: (missing: string, gifts: string) => `Add ${missing} more and choose a gift: ${gifts}`,
  presentFrom: (amount: string) => `From ${amount}`,
  presentLabel: 'Gift',
  presentFree: 'Free',
  summaryExtras: (n: number) => (n === 1 ? '+1 extra' : `+${n} extras`),
  summaryProducts: (n: number) => (n === 1 ? '1 product' : `${n} products`),
  callStaffDone: 'Our team has been notified. Someone will be with you shortly.',
  tagline: 'Facial training by the hands of our therapists. No needles.',
  chooseLanguage: 'Choose your language to start',
  bookThis: 'Book this treatment',
  sourceNote: 'Description and photo: 360face.pt',
  progress: ['Treatment', 'Day & time', 'Extras', 'Details', 'Confirm'],
  stepOf: (n: number, total: number) => `Step ${n} of ${total}`,
  hourLabel: (h: string) => `${h}:00`,
  welcome: 'Welcome to 360°FACE',
  welcomeSub: 'Tap to start',
  menuTitle: 'Welcome! How can we help you today?',
  menuBook: 'Book a treatment',
  menuBookSub: 'Today or another day',
  menuCheckin: 'I have a booking',
  menuCheckinSub: 'Check in',
  chooseService: 'What would you like today?',
  kinds: { face: 'Face', body: 'Body', skin: 'Skin', combo: 'Combos', addon: 'Extras' },
  minutes: 'min',
  chooseDate: 'Choose a day',
  chooseTime: 'When suits you best?',
  with: 'with',
  noSlots: 'No free times on this day. Please choose another day.',
  addonsTitle: 'Would you like to add something?',
  addonsSub: 'Optional. You can continue without extras.',
  continue: 'Continue',
  skip: 'Continue without extras',
  detailsTitle: 'Your details',
  fields: {
    fullName: 'First and last name',
    phone: 'Mobile number',
    email: 'Email',
  },
  fieldErrors: {
    fullName: 'Please enter your name.',
    phone: 'Invalid mobile number.',
    email: 'Invalid email.',
    privacy: 'You need to accept to continue.',
  },
  privacy: 'I agree that 360°FACE processes my data to manage this booking.',
  marketing: 'I would like to receive news and offers (optional).',
  reviewTitle: 'Confirm your booking',
  total: 'Total',
  confirm: 'Confirm booking',
  sending: 'Sending…',
  paymentTitle: 'How would you like to pay?',
  paymentSub: 'You pay after the treatment. Nothing is charged now.',
  paymentLater: 'Decide later',
  methods: {
    card_terminal: 'Card',
    mbway: 'MB WAY',
    cash: 'Cash',
    bank_transfer: 'Bank transfer',
    gift_card: 'Pay with a gift card',
    qr_transfer: 'QR code',
  },
  doneTitle: (name: string) => `Thank you, ${name}!`,
  doneBooked: 'Your booking is confirmed.',
  doneFuture: 'On the day of your visit, tap “I have a booking” on this screen. You’ll choose how to pay then.',
  doneRequested: 'Your request is registered. Our team will confirm the booking shortly.',
  doneCheckedIn: 'You are checked in. Please take a seat — your therapist has been notified.',
  doneNewCustomer: 'See you soon!',
  checkinTitle: 'Enter your mobile number',
  checkinFind: 'Find my booking',
  scanOr: 'or',
  scanHint: 'Hold the QR code of your 360°FACE card to the scanner',
  cardNoBooking: "We couldn't find a booking for today with this card. Please enter your mobile number.",
  checkinMatches: 'Confirm your booking for today',
  confirmBooking: 'I confirm',
  checkinNone: 'We could not find a booking for today with this number.',
  checkinBook: 'Book now',
  back: 'Back',
  callStaff: 'Call staff',
  loading: 'Loading…',
  newStart: 'New booking',
  errors: {
    CARD_NOT_FOUND: 'Card not recognised. Please enter your mobile number.',
    NETWORK: 'No internet connection. Please try again in a moment.',
    CRM_UNAVAILABLE: 'The booking system is not responding. Try again or call staff.',
    CRM_RATE_LIMITED: 'Too many requests at once. Please try again in a moment.',
    TOO_MANY_REQUESTS: 'Too many attempts. Wait a minute or call staff.',
    SLOT_TAKEN: 'This time was just taken. Please choose another one.',
    RECOGNITION_EXPIRED: 'For your security, please confirm your details once more.',
    NO_TIME_FOR_ADDON: 'There is no time for this extra before the next appointment today.',
    VISIT_ALREADY_DONE: 'This booking is already completed. If you need help, please call staff.',
    VISIT_NOT_EDITABLE: 'This visit can no longer be changed here. Please call staff.',
    BOOKING_NOT_FOUND: 'We could not find this booking. Please call staff.',
    VALIDATION_FAILED: 'Please check the details you entered.',
    PRODUCT_UNAVAILABLE: 'This product is no longer available.',
    UNKNOWN_GIFT: 'This gift card is not available. Please call staff.',
    QUESTIONNAIRE_VERSION_MISMATCH: 'The form has been updated. Please start again or call staff.',
    QUESTIONNAIRE_INCOMPLETE: 'Please answer every question.',
    default: 'Something went wrong. Try again or call staff.',
  },
  retry: 'Try again',
};

const fr: Messages = {
  menuClassPass: 'ClassPass',
  menuClassPassSub: 'J’ai réservé via ClassPass',
  cpTitle: 'Choisissez l’heure de votre réservation',
  cpNone: 'Aucune réservation ClassPass dans les prochaines heures.',
  cpNotFound: 'Vous ne trouvez pas votre heure ?',
  cpChat: 'Si vous ne trouvez pas votre réservation, écrivez-nous dans le chat de votre application ClassPass.',
  cpIsYou: (name: string) => `Êtes-vous ${name} ?`,
  cpYes: 'Oui, c’est moi',
  cpNo: 'Non',
  cpAddonsTitle: 'Souhaitez-vous ajouter quelque chose à votre séance ?',
  cpNoTime: 'Pas assez de temps avant le rendez-vous suivant',
  nifNote: '* Pour une facture avec NIF, indiquez le numéro à votre thérapeute ou au paiement.',
  countryTitle: 'Indicatif du pays',
  countrySearch: 'Rechercher un pays ou un indicatif',
  notFoundTitle: 'Rendez-vous introuvable',
  notFoundText: 'Vérifiez votre numéro de portable et l’indicatif du pays.',
  notFoundAgain: 'Toujours introuvable. L’équipe vous aide tout de suite.',
  tryAgain: 'Réessayer',
  callAdmin: 'Appeler l’équipe',
  giftPhoneTitle: 'Votre numéro de portable',
  giftPhoneSub: 'Pour vous envoyer le reçu et vous contacter si besoin.',
  buy: 'Acheter',
  qTitle: 'Avez-vous déjà rempli notre fiche client ?',
  qSub: 'Elle est obligatoire avant tout soin.',
  qYes: 'Oui, déjà remplie',
  qNo: 'Non, pas encore',
  qConfirm: 'Je confirme avoir rempli la fiche client et que mes informations de santé n’ont pas changé.',
  qNeeded: 'Pas de problème. Votre thérapeute vous donnera la fiche avant le soin.',
  qfOffer:
    'Vous pouvez remplir la fiche maintenant, ici sur l’écran. Quelques questions rapides sur votre santé (environ 1 minute).',
  qfStart: 'Remplir maintenant',
  qfPaper: 'Je préfère la fiche papier',
  qfYes: 'Oui',
  qfNo: 'Non',
  qfDetailHint: 'Précisions (facultatif)',
  qfName: 'Nom complet',
  qfMissing: 'Répondez à toutes les questions, indiquez votre nom et donnez votre consentement.',
  qfSubmit: 'Envoyer à ma thérapeute',
  qfCancel: 'Annuler',
  qfPrivate: 'Vos réponses sont transmises en toute sécurité à votre thérapeute et ne restent pas sur cet écran.',
  qfDraft: 'Questions provisoires (en cours de validation).',
  qfLoadError: 'Impossible d’ouvrir la fiche. Choisissez la fiche papier ou appelez l’équipe.',
  qfStepAbout: 'Vous',
  qfStepHealth: 'Santé',
  qfStepAesthetic: 'Actes esthétiques',
  qfStepSign: 'Confirmation',
  qfBirth: 'Date de naissance',
  qfBirthHint: 'JJ/MM/AAAA',
  qfContact: 'Comment préférez-vous être contacté(e) ?',
  qfContactEmail: 'E-mail',
  qfContactWhatsapp: 'WhatsApp',
  qfContactTelegram: 'Telegram',
  qfContactPhone: 'Appel',
  qfPressure: 'Intensité du massage',
  qfPressureHint:
    '1 = très doux, 3 = moyen, 5 = très intense. Première fois ? Nous conseillons 2–3. Réglable pendant la séance.',
  qfSimilar: 'Avez-vous déjà fait des soins similaires ?',
  qfHeard: 'Comment nous avez-vous connus ?',
  qfHeardInstagram: 'Instagram',
  qfHeardGoogle: 'Google',
  qfHeardFriend: 'Recommandation',
  qfHeardClasspass: 'ClassPass',
  qfHeardTiktok: 'TikTok',
  qfHeardAi: 'Assistant IA (ChatGPT, Claude…)',
  qfHeardPassing: 'En passant devant le studio',
  qfHeardOther: 'Autre',
  qfHealthRead: 'Lisez attentivement la liste :',
  qfNoneApply: 'Rien dans cette liste ne me concerne',
  qfSomeApply: 'Quelque chose de cette liste me concerne',
  qfTickWhich: 'Touchez ce qui vous concerne. Votre praticienne ne le voit qu’aujourd’hui.',
  qfNote: 'Commentaire (facultatif)',
  qfAestheticWhat: 'Quoi, quelle zone et quand ?',
  qfSignHere: 'Signez ici avec le doigt',
  qfClear: 'Effacer',
  qfNext: 'Continuer',
  qfPrev: 'Retour',
  qfPageMissing: 'Complétez les champs indiqués.',
  menuGift: 'Acheter une carte cadeau',
  menuGiftSub: 'Un cadeau prêt à emporter',
  giftTitle: 'Carte cadeau',
  giftSub: 'Choisissez le montant. Le certificat vaut ce montant sur tout soin.',
  giftHowTitle: 'Comment souhaitez-vous le recevoir ?',
  giftPickup: 'Retirer maintenant au studio',
  giftPickupSub: 'L’équipe vous remet l’enveloppe en 10–15 minutes, après paiement.',
  giftEmail: 'Recevoir par e-mail',
  giftEmailSub: 'Nous transmettons la demande à l’équipe ; le paiement est convenu avec vous par e-mail.',
  giftEmailField: 'Votre e-mail',
  kbDone: 'OK',
  kbSpace: 'espace',
  giftCardTitle: 'Pour qui est le cadeau ?',
  giftCardSub:
    'Ces informations figurent sur le certificat. Après l’envoi, nous vous écrivons avec les moyens de paiement.',
  giftTo: 'Pour (nom)',
  giftFrom: 'De (votre nom)',
  giftMessage: 'Message (facultatif)',
  giftSend: 'Envoyer la demande',
  doneGiftEmail: (v: string) =>
    `Votre demande de certificat de ${v} est enregistrée. Notre équipe vous écrira pour convenir du paiement et envoyer le certificat.`,
  thanks: 'Merci !',
  doneGift: (v: string) => `L’équipe vous remet le certificat de ${v} en 10–15 minutes, après paiement.`,
  languageTitle: 'Choisissez votre langue',
  productsTitle: 'Pour la maison',
  productsSub: 'Prolongez l’effet de votre soin chez vous. Facultatif.',
  productAdd: 'Ajouter',
  productAdded: 'Ajouté',
  productsSkip: 'Continuer sans produits',
  productsNone: 'Aucun produit disponible pour le moment.',
  summaryTotal: 'Total',
  presentTitle: 'Votre cadeau',
  presentSub: (amount: string) => `Avec ${amount} de soins, choisissez un cadeau de la maison.`,
  presentNone: 'Continuer sans cadeau',
  presentHint: (missing: string, gifts: string) => `Ajoutez ${missing} et choisissez un cadeau : ${gifts}`,
  presentFrom: (amount: string) => `À partir de ${amount}`,
  presentLabel: 'Cadeau',
  presentFree: 'Offert',
  summaryExtras: (n: number) => (n === 1 ? '+1 option' : `+${n} options`),
  summaryProducts: (n: number) => (n === 1 ? '1 produit' : `${n} produits`),
  callStaffDone: 'L’équipe a été prévenue. Quelqu’un arrive tout de suite.',
  tagline: 'Un entraînement du visage par les mains de nos thérapeutes. Sans aiguilles.',
  chooseLanguage: 'Choisissez votre langue pour commencer',
  bookThis: 'Réserver ce soin',
  sourceNote: 'Description et photo : 360face.pt',
  progress: ['Soin', 'Jour et heure', 'Options', 'Coordonnées', 'Confirmer'],
  stepOf: (n: number, total: number) => `Étape ${n} sur ${total}`,
  hourLabel: (h: string) => `${h} h`,
  welcome: 'Bienvenue chez 360°FACE',
  welcomeSub: 'Touchez pour commencer',
  menuTitle: 'Comment pouvons-nous vous aider ?',
  menuBook: 'Réserver un soin',
  menuBookSub: 'Aujourd’hui ou un autre jour',
  menuCheckin: 'J’ai un rendez-vous',
  menuCheckinSub: 'M’enregistrer',
  chooseService: 'Choisissez votre soin',
  kinds: { face: 'Visage', body: 'Corps', skin: 'Peau', combo: 'Combinés', addon: 'Options' },
  minutes: 'min',
  chooseDate: 'Choisissez un jour',
  chooseTime: 'Choisissez une heure',
  with: 'avec',
  noSlots: 'Aucun créneau libre ce jour-là. Choisissez un autre jour.',
  addonsTitle: 'Souhaitez-vous ajouter quelque chose ?',
  addonsSub: 'Facultatif. Vous pouvez continuer sans options.',
  continue: 'Continuer',
  skip: 'Continuer sans options',
  detailsTitle: 'Vos coordonnées',
  fields: {
    fullName: 'Prénom et nom',
    phone: 'Téléphone portable',
    email: 'E-mail',
  },
  fieldErrors: {
    fullName: 'Indiquez votre nom.',
    phone: 'Numéro de portable invalide.',
    email: 'E-mail invalide.',
    privacy: 'Vous devez accepter pour continuer.',
  },
  privacy: 'J’accepte que 360°FACE traite mes données pour gérer ce rendez-vous.',
  marketing: 'Je souhaite recevoir des nouveautés et des offres (facultatif).',
  reviewTitle: 'Confirmez votre rendez-vous',
  total: 'Total',
  confirm: 'Confirmer le rendez-vous',
  sending: 'Envoi…',
  paymentTitle: 'Comment souhaitez-vous payer ?',
  paymentSub: 'Le paiement se fait après le soin. Rien n’est débité maintenant.',
  paymentLater: 'Décider plus tard',
  methods: {
    card_terminal: 'Carte',
    mbway: 'MB WAY',
    cash: 'Espèces',
    bank_transfer: 'Virement',
    gift_card: 'Payer avec une carte cadeau',
    qr_transfer: 'Code QR',
  },
  doneTitle: (name: string) => `Merci, ${name} !`,
  doneBooked: 'Votre rendez-vous est confirmé.',
  doneFuture:
    'Le jour de votre visite, touchez « J’ai un rendez-vous » sur cet écran. Vous choisirez alors comment payer.',
  doneRequested: 'Votre demande est enregistrée. L’équipe confirmera le rendez-vous rapidement.',
  doneCheckedIn: 'Vous êtes enregistré(e). Installez-vous, votre thérapeute a été prévenue.',
  doneNewCustomer: 'À bientôt !',
  checkinTitle: 'Indiquez votre numéro de portable',
  checkinFind: 'Trouver mon rendez-vous',
  scanOr: 'ou',
  scanHint: 'Présentez le QR de votre carte 360°FACE au lecteur',
  cardNoBooking: 'Aucun rendez-vous aujourd’hui avec cette carte. Indiquez votre numéro de portable.',
  checkinMatches: 'Confirmez votre rendez-vous d’aujourd’hui',
  confirmBooking: 'Je confirme',
  checkinNone: 'Aucun rendez-vous trouvé aujourd’hui avec ce numéro.',
  checkinBook: 'Réserver maintenant',
  back: 'Retour',
  callStaff: 'Appeler l’équipe',
  loading: 'Chargement…',
  newStart: 'Nouveau rendez-vous',
  errors: {
    CARD_NOT_FOUND: 'Carte non reconnue. Indiquez votre numéro de portable.',
    NETWORK: 'Pas de connexion internet. Réessayez dans un instant.',
    CRM_UNAVAILABLE: 'Le système de réservation ne répond pas. Réessayez ou appelez l’équipe.',
    CRM_RATE_LIMITED: 'Trop de demandes en même temps. Réessayez dans un instant.',
    TOO_MANY_REQUESTS: 'Trop de tentatives. Patientez une minute ou appelez l’équipe.',
    SLOT_TAKEN: 'Ce créneau vient d’être pris. Choisissez-en un autre.',
    RECOGNITION_EXPIRED: 'Par sécurité, confirmez vos coordonnées encore une fois.',
    NO_TIME_FOR_ADDON: 'Il n’y a plus le temps pour ce supplément avant le prochain rendez-vous.',
    VISIT_ALREADY_DONE: "Ce rendez-vous est déjà terminé. Besoin d'aide ? Appelez l'équipe.",
    VISIT_NOT_EDITABLE: "Cette visite ne peut plus être modifiée ici. Appelez l'équipe, s'il vous plaît.",
    BOOKING_NOT_FOUND: 'Rendez-vous introuvable. Appelez l’équipe, s’il vous plaît.',
    VALIDATION_FAILED: 'Vérifiez les informations saisies.',
    PRODUCT_UNAVAILABLE: 'Ce produit n’est plus disponible.',
    UNKNOWN_GIFT: 'Cette carte cadeau n’est pas disponible. Appelez l’équipe, s’il vous plaît.',
    QUESTIONNAIRE_VERSION_MISMATCH: 'La fiche a été mise à jour. Recommencez ou appelez l’équipe.',
    QUESTIONNAIRE_INCOMPLETE: 'Répondez à toutes les questions.',
    default: 'Un problème est survenu. Réessayez ou appelez l’équipe.',
  },
  retry: 'Réessayer',
};

const es: Messages = {
  menuClassPass: 'ClassPass',
  menuClassPassSub: 'Reservé con ClassPass',
  cpTitle: 'Elija la hora de su reserva',
  cpNone: 'No hay reservas de ClassPass en las próximas horas.',
  cpNotFound: '¿No encuentra su hora?',
  cpChat: 'Si no encuentra su reserva, escríbanos en el chat de su app ClassPass.',
  cpIsYou: (name: string) => `¿Es usted ${name}?`,
  cpYes: 'Sí, soy yo',
  cpNo: 'No',
  cpAddonsTitle: '¿Quiere añadir algo a su sesión?',
  cpNoTime: 'No cabe antes de la siguiente cita',
  nifNote: '* Para factura con NIF, indique el número a su terapeuta o al pagar.',
  countryTitle: 'Prefijo del país',
  countrySearch: 'Buscar país o prefijo',
  notFoundTitle: 'Cita no encontrada',
  notFoundText: 'Revise su número de móvil y el prefijo del país.',
  notFoundAgain: 'Seguimos sin encontrarla. El equipo le ayuda enseguida.',
  tryAgain: 'Intentar de nuevo',
  callAdmin: 'Llamar al equipo',
  giftPhoneTitle: 'Su móvil',
  giftPhoneSub: 'Para enviarle el comprobante y contactarle si hace falta.',
  buy: 'Comprar',
  qTitle: '¿Ya ha rellenado nuestra ficha de cliente?',
  qSub: 'Es obligatoria antes de cualquier tratamiento.',
  qYes: 'Sí, ya la rellené',
  qNo: 'No, todavía no',
  qConfirm: 'Confirmo que ya he rellenado la ficha de cliente y que mis datos de salud no han cambiado.',
  qNeeded: 'No pasa nada. Su terapeuta le dará la ficha antes del tratamiento.',
  qfOffer:
    'Puede rellenar la ficha ahora, aquí en la pantalla. Son unas preguntas rápidas sobre su salud (alrededor de 1 minuto).',
  qfStart: 'Rellenar ahora',
  qfPaper: 'Prefiero la ficha en papel',
  qfYes: 'Sí',
  qfNo: 'No',
  qfDetailHint: 'Detalles (opcional)',
  qfName: 'Nombre completo',
  qfMissing: 'Responda a todas las preguntas, indique su nombre y dé su consentimiento.',
  qfSubmit: 'Enviar a mi terapeuta',
  qfCancel: 'Cancelar',
  qfPrivate: 'Sus respuestas llegan de forma segura a su terapeuta y no se quedan en esta pantalla.',
  qfDraft: 'Preguntas provisionales (pendientes de aprobación).',
  qfLoadError: 'No se pudo abrir la ficha. Elija la ficha en papel o llame al equipo.',
  qfStepAbout: 'Sobre usted',
  qfStepHealth: 'Salud',
  qfStepAesthetic: 'Procedimientos estéticos',
  qfStepSign: 'Confirmación',
  qfBirth: 'Fecha de nacimiento',
  qfBirthHint: 'DD/MM/AAAA',
  qfContact: '¿Cómo prefiere que le contactemos?',
  qfContactEmail: 'E-mail',
  qfContactWhatsapp: 'WhatsApp',
  qfContactTelegram: 'Telegram',
  qfContactPhone: 'Llamada',
  qfPressure: 'Intensidad del masaje',
  qfPressureHint:
    '1 = muy suave, 3 = media, 5 = muy intensa. ¿Primera vez? Recomendamos 2–3. Se puede ajustar durante la sesión.',
  qfSimilar: '¿Ha hecho tratamientos similares antes?',
  qfHeard: '¿Cómo nos conoció?',
  qfHeardInstagram: 'Instagram',
  qfHeardGoogle: 'Google',
  qfHeardFriend: 'Recomendación',
  qfHeardClasspass: 'ClassPass',
  qfHeardTiktok: 'TikTok',
  qfHeardAi: 'Asistente de IA (ChatGPT, Claude…)',
  qfHeardPassing: 'Pasé por el estudio',
  qfHeardOther: 'Otro',
  qfHealthRead: 'Lea la lista con atención:',
  qfNoneApply: 'Nada de esta lista se aplica a mí',
  qfSomeApply: 'Tengo algo de esta lista',
  qfTickWhich: 'Toque lo que se aplica. Su terapeuta lo ve solo hoy.',
  qfNote: 'Comentario (opcional)',
  qfAestheticWhat: '¿Qué, en qué zona y cuándo?',
  qfSignHere: 'Firme aquí con el dedo',
  qfClear: 'Borrar',
  qfNext: 'Continuar',
  qfPrev: 'Atrás',
  qfPageMissing: 'Complete los campos marcados.',
  menuGift: 'Comprar una tarjeta regalo',
  menuGiftSub: 'Un regalo listo para llevar',
  giftTitle: 'Tarjeta regalo',
  giftSub: 'Elija el importe. El certificado vale ese importe en cualquier tratamiento.',
  giftHowTitle: '¿Cómo quiere recibirlo?',
  giftPickup: 'Recoger ahora en el estudio',
  giftPickupSub: 'El equipo le entrega el sobre en 10–15 minutos, tras el pago.',
  giftEmail: 'Recibir por e-mail',
  giftEmailSub: 'Enviamos la solicitud al equipo; acordamos el pago con usted por e-mail.',
  giftEmailField: 'Su e-mail',
  kbDone: 'Listo',
  kbSpace: 'espacio',
  giftCardTitle: '¿Para quién es el regalo?',
  giftCardSub: 'Estos datos van en el certificado. Tras enviar, le escribimos por e-mail con las formas de pago.',
  giftTo: 'Para (nombre)',
  giftFrom: 'De (su nombre)',
  giftMessage: 'Mensaje (opcional)',
  giftSend: 'Enviar solicitud',
  doneGiftEmail: (v: string) =>
    `Hemos recibido su solicitud de un certificado de ${v}. Nuestro equipo le escribirá para acordar el pago y enviar el certificado.`,
  thanks: '¡Gracias!',
  doneGift: (v: string) => `El equipo le entrega el certificado de ${v} en 10–15 minutos, tras el pago.`,
  languageTitle: 'Elija su idioma',
  productsTitle: 'Para casa',
  productsSub: 'Mantenga el efecto del tratamiento en casa. Opcional.',
  productAdd: 'Añadir',
  productAdded: 'Añadido',
  productsSkip: 'Continuar sin productos',
  productsNone: 'Ahora mismo no hay productos disponibles.',
  summaryTotal: 'Total',
  presentTitle: 'Su regalo',
  presentSub: (amount: string) => `Con ${amount} en tratamientos, elija un regalo de la casa.`,
  presentNone: 'Continuar sin regalo',
  presentHint: (missing: string, gifts: string) => `Añada ${missing} más y elija un regalo: ${gifts}`,
  presentFrom: (amount: string) => `A partir de ${amount}`,
  presentLabel: 'Regalo',
  presentFree: 'Gratis',
  summaryExtras: (n: number) => (n === 1 ? '+1 extra' : `+${n} extras`),
  summaryProducts: (n: number) => (n === 1 ? '1 producto' : `${n} productos`),
  callStaffDone: 'Hemos avisado al equipo. Enseguida le atienden.',
  tagline: 'Entrenamiento facial con las manos de nuestras terapeutas. Sin agujas.',
  chooseLanguage: 'Elija su idioma para empezar',
  bookThis: 'Reservar este tratamiento',
  sourceNote: 'Descripción y foto: 360face.pt',
  progress: ['Tratamiento', 'Día y hora', 'Extras', 'Datos', 'Confirmar'],
  stepOf: (n: number, total: number) => `Paso ${n} de ${total}`,
  hourLabel: (h: string) => `${h}:00`,
  welcome: 'Bienvenida a 360°FACE',
  welcomeSub: 'Toque para empezar',
  menuTitle: '¿Cómo podemos ayudarle?',
  menuBook: 'Reservar un tratamiento',
  menuBookSub: 'Hoy u otro día',
  menuCheckin: 'Ya tengo cita',
  menuCheckinSub: 'Registrar llegada',
  chooseService: 'Elija su tratamiento',
  kinds: { face: 'Rostro', body: 'Cuerpo', skin: 'Piel', combo: 'Combinados', addon: 'Extras' },
  minutes: 'min',
  chooseDate: 'Elija el día',
  chooseTime: 'Elija la hora',
  with: 'con',
  noSlots: 'No hay horas libres este día. Elija otro día.',
  addonsTitle: '¿Quiere añadir algo?',
  addonsSub: 'Opcional. Puede continuar sin extras.',
  continue: 'Continuar',
  skip: 'Continuar sin extras',
  detailsTitle: 'Sus datos',
  fields: {
    fullName: 'Nombre y apellido',
    phone: 'Móvil',
    email: 'Correo electrónico',
  },
  fieldErrors: {
    fullName: 'Indique su nombre.',
    phone: 'Número de móvil no válido.',
    email: 'Correo electrónico no válido.',
    privacy: 'Debe aceptar para continuar.',
  },
  privacy: 'Acepto que 360°FACE trate mis datos para gestionar esta cita.',
  marketing: 'Quiero recibir novedades y ofertas (opcional).',
  reviewTitle: 'Confirme su cita',
  total: 'Total',
  confirm: 'Confirmar cita',
  sending: 'Enviando…',
  paymentTitle: '¿Cómo prefiere pagar?',
  paymentSub: 'El pago se hace después del tratamiento. No se cobra nada ahora.',
  paymentLater: 'Decidir más tarde',
  methods: {
    card_terminal: 'Tarjeta',
    mbway: 'MB WAY',
    cash: 'Efectivo',
    bank_transfer: 'Transferencia',
    gift_card: 'Pagar con tarjeta regalo',
    qr_transfer: 'Código QR',
  },
  doneTitle: (name: string) => `¡Gracias, ${name}!`,
  doneBooked: 'Su cita está confirmada.',
  doneFuture: 'El día de su visita, toque «Tengo una cita» en esta pantalla. Entonces elegirá cómo pagar.',
  doneRequested: 'Su solicitud está registrada. El equipo confirmará la cita en breve.',
  doneCheckedIn: 'Llegada registrada. Tome asiento, por favor: su terapeuta ya está avisada.',
  doneNewCustomer: '¡Hasta pronto!',
  checkinTitle: 'Indique su número de móvil',
  checkinFind: 'Buscar mi cita',
  scanOr: 'o',
  scanHint: 'Acerque el QR de su tarjeta 360°FACE al lector',
  cardNoBooking: 'No encontramos una cita para hoy con esta tarjeta. Indique su móvil.',
  checkinMatches: 'Confirme su cita de hoy',
  confirmBooking: 'Confirmo',
  checkinNone: 'No encontramos citas para hoy con este número.',
  checkinBook: 'Reservar ahora',
  back: 'Volver',
  callStaff: 'Llamar al equipo',
  loading: 'Cargando…',
  newStart: 'Nueva cita',
  errors: {
    CARD_NOT_FOUND: 'Tarjeta no reconocida. Indique su móvil.',
    NETWORK: 'Sin conexión a internet. Inténtelo de nuevo en un momento.',
    CRM_UNAVAILABLE: 'El sistema de reservas no responde. Inténtelo de nuevo o llame al equipo.',
    CRM_RATE_LIMITED: 'Demasiadas solicitudes a la vez. Inténtelo de nuevo en un momento.',
    TOO_MANY_REQUESTS: 'Demasiados intentos. Espere un minuto o llame al equipo.',
    SLOT_TAKEN: 'Esta hora se acaba de ocupar. Elija otra, por favor.',
    RECOGNITION_EXPIRED: 'Por seguridad, confirme sus datos una vez más.',
    NO_TIME_FOR_ADDON: 'No queda tiempo para este extra antes de la próxima cita.',
    VISIT_ALREADY_DONE: 'Esta cita ya está terminada. Si necesita ayuda, llame al equipo.',
    VISIT_NOT_EDITABLE: 'Esta visita ya no se puede cambiar aquí. Llame al equipo, por favor.',
    BOOKING_NOT_FOUND: 'No encontramos esta cita. Llame al equipo, por favor.',
    VALIDATION_FAILED: 'Revise los datos introducidos.',
    PRODUCT_UNAVAILABLE: 'Este producto ya no está disponible.',
    UNKNOWN_GIFT: 'Esta tarjeta regalo no está disponible. Llame al equipo, por favor.',
    QUESTIONNAIRE_VERSION_MISMATCH: 'La ficha se ha actualizado. Empiece de nuevo o llame al equipo.',
    QUESTIONNAIRE_INCOMPLETE: 'Responda a todas las preguntas.',
    default: 'Algo salió mal. Inténtelo de nuevo o llame al equipo.',
  },
  retry: 'Intentar de nuevo',
};

const ru: Messages = {
  menuClassPass: 'ClassPass',
  menuClassPassSub: 'Я записан(а) через ClassPass',
  cpTitle: 'Выберите время вашей записи',
  cpNone: 'В ближайшие часы записей ClassPass нет.',
  cpNotFound: 'Не нашли своё время?',
  cpChat: 'Если не нашли свою запись, напишите нам, пожалуйста, в чат вашего приложения ClassPass.',
  cpIsYou: (name: string) => `Вы — ${name}?`,
  cpYes: 'Да, это я',
  cpNo: 'Нет',
  cpAddonsTitle: 'Хотите что-то добавить к сеансу?',
  cpNoTime: 'Не помещается до следующей записи',
  nifNote: '* Для счёта (fatura) с NIF назовите номер мастеру или укажите его при оплате.',
  countryTitle: 'Код страны',
  countrySearch: 'Поиск страны или кода',
  notFoundTitle: 'Запись не найдена',
  notFoundText: 'Проверьте номер телефона и код страны.',
  notFoundAgain: 'Снова не нашли. Сотрудник сейчас поможет.',
  tryAgain: 'Ввести ещё раз',
  callAdmin: 'Позвать администратора',
  giftPhoneTitle: 'Ваш мобильный',
  giftPhoneSub: 'Чтобы отправить чек и связаться при необходимости.',
  buy: 'Купить',
  qTitle: 'Вы уже заполняли нашу анкету клиента?',
  qSub: 'Она обязательна перед любой процедурой.',
  qYes: 'Да, заполнял(а)',
  qNo: 'Нет, ещё нет',
  qConfirm: 'Подтверждаю, что заполнял(а) анкету клиента и мои данные о здоровье не изменились.',
  qNeeded: 'Ничего страшного. Мастер даст вам анкету перед процедурой.',
  qfOffer: 'Анкету можно заполнить прямо сейчас на экране. Несколько коротких вопросов о здоровье (около 1 минуты).',
  qfStart: 'Заполнить сейчас',
  qfPaper: 'Лучше бумажную анкету',
  qfYes: 'Да',
  qfNo: 'Нет',
  qfDetailHint: 'Подробности (необязательно)',
  qfName: 'Имя и фамилия',
  qfMissing: 'Ответьте на все вопросы, укажите имя и дайте согласие.',
  qfSubmit: 'Отправить мастеру',
  qfCancel: 'Отмена',
  qfPrivate: 'Ответы надёжно передаются вашему мастеру и не сохраняются на этом экране.',
  qfDraft: 'Предварительные вопросы (на согласовании).',
  qfLoadError: 'Не удалось открыть анкету. Выберите бумажную анкету или позовите сотрудника.',
  qfStepAbout: 'О вас',
  qfStepHealth: 'Здоровье',
  qfStepAesthetic: 'Эстетические процедуры',
  qfStepSign: 'Подтверждение',
  qfBirth: 'Дата рождения',
  qfBirthHint: 'ДД/ММ/ГГГГ',
  qfContact: 'Как удобнее с вами связаться?',
  qfContactEmail: 'E-mail',
  qfContactWhatsapp: 'WhatsApp',
  qfContactTelegram: 'Telegram',
  qfContactPhone: 'Звонок',
  qfPressure: 'Интенсивность массажа',
  qfPressureHint:
    '1 = очень мягко, 3 = средне, 5 = очень интенсивно. Впервые? Рекомендуем 2–3. Можно изменить во время сеанса.',
  qfSimilar: 'Делали ли вы похожие процедуры раньше?',
  qfHeard: 'Как вы о нас узнали?',
  qfHeardInstagram: 'Instagram',
  qfHeardGoogle: 'Google',
  qfHeardFriend: 'Рекомендация',
  qfHeardClasspass: 'ClassPass',
  qfHeardTiktok: 'TikTok',
  qfHeardAi: 'ИИ-ассистент (ChatGPT, Claude…)',
  qfHeardPassing: 'Проходил(а) мимо студии',
  qfHeardOther: 'Другое',
  qfHealthRead: 'Внимательно прочитайте список:',
  qfNoneApply: 'Ничего из этого списка ко мне не относится',
  qfSomeApply: 'У меня есть что-то из списка',
  qfTickWhich: 'Отметьте, что относится к вам. Мастер видит это только сегодня.',
  qfNote: 'Комментарий (необязательно)',
  qfAestheticWhat: 'Что, в какой зоне и когда?',
  qfSignHere: 'Распишитесь здесь пальцем',
  qfClear: 'Стереть',
  qfNext: 'Далее',
  qfPrev: 'Назад',
  qfPageMissing: 'Заполните отмеченные поля.',
  menuGift: 'Купить сертификат',
  menuGiftSub: 'Готовый подарок с собой',
  giftTitle: 'Подарочный сертификат',
  giftSub: 'Выберите сумму. Сертификат действует на эту сумму для любой процедуры.',
  giftHowTitle: 'Как вы хотите получить сертификат?',
  giftPickup: 'Забрать сейчас в студии',
  giftPickupSub: 'Сотрудник выдаст конверт через 10–15 минут после оплаты.',
  giftEmail: 'Получить по e-mail',
  giftEmailSub: 'Мы передадим запрос сотруднику; об оплате договоримся с вами по почте.',
  giftEmailField: 'Ваш e-mail',
  kbDone: 'Готово',
  kbSpace: 'пробел',
  giftCardTitle: 'Для кого подарок?',
  giftCardSub: 'Эти данные будут на сертификате. После отправки мы напишем вам на e-mail со способами оплаты.',
  giftTo: 'Кому (имя)',
  giftFrom: 'От кого (ваше имя)',
  giftMessage: 'Пожелание (необязательно)',
  giftSend: 'Отправить заявку',
  doneGiftEmail: (v: string) =>
    `Запрос на сертификат на ${v} принят. Наш сотрудник напишет вам, чтобы договориться об оплате и отправить сертификат.`,
  thanks: 'Спасибо!',
  doneGift: (v: string) => `Сотрудник выдаст сертификат на ${v} через 10–15 минут после оплаты.`,
  languageTitle: 'Выберите язык',
  productsTitle: 'Для дома',
  productsSub: 'Сохраните эффект процедуры дома. Необязательно.',
  productAdd: 'Добавить',
  productAdded: 'Добавлено',
  productsSkip: 'Продолжить без покупок',
  productsNone: 'Сейчас нет доступных товаров.',
  summaryTotal: 'Итого',
  presentTitle: 'Ваш подарок',
  presentSub: (amount: string) => `При заказе на ${amount} выберите подарок от студии.`,
  presentNone: 'Продолжить без подарка',
  presentHint: (missing: string, gifts: string) => `Добавьте ещё ${missing} и выберите подарок: ${gifts}`,
  presentFrom: (amount: string) => `От ${amount}`,
  presentLabel: 'Подарок',
  presentFree: 'Бесплатно',
  summaryExtras: (n: number) => `+${n} доп.`,
  summaryProducts: (n: number) => `товаров: ${n}`,
  callStaffDone: 'Мы позвали сотрудника. К вам скоро подойдут.',
  tagline: 'Тренировка лица руками наших мастеров. Без уколов.',
  chooseLanguage: 'Выберите язык, чтобы начать',
  bookThis: 'Записаться на процедуру',
  sourceNote: 'Описание и фото: 360face.pt',
  progress: ['Процедура', 'День и время', 'Дополнения', 'Данные', 'Подтверждение'],
  stepOf: (n: number, total: number) => `Шаг ${n} из ${total}`,
  hourLabel: (h: string) => `${h}:00`,
  welcome: 'Добро пожаловать в 360°FACE',
  welcomeSub: 'Коснитесь экрана, чтобы начать',
  menuTitle: 'Чем мы можем помочь?',
  menuBook: 'Записаться на процедуру',
  menuBookSub: 'Сегодня или в другой день',
  menuCheckin: 'У меня есть запись',
  menuCheckinSub: 'Отметиться о приходе',
  chooseService: 'Выберите процедуру',
  kinds: { face: 'Лицо', body: 'Тело', skin: 'Кожа', combo: 'Комбо', addon: 'Дополнения' },
  minutes: 'мин',
  chooseDate: 'Выберите день',
  chooseTime: 'Выберите время',
  with: 'мастер',
  noSlots: 'В этот день нет свободного времени. Выберите другой день.',
  addonsTitle: 'Хотите что-то добавить?',
  addonsSub: 'Необязательно. Можно продолжить без дополнений.',
  continue: 'Продолжить',
  skip: 'Продолжить без дополнений',
  detailsTitle: 'Ваши данные',
  fields: {
    fullName: 'Имя и фамилия',
    phone: 'Мобильный телефон',
    email: 'Эл. почта',
  },
  fieldErrors: {
    fullName: 'Укажите имя.',
    phone: 'Неверный номер телефона.',
    email: 'Неверный адрес эл. почты.',
    privacy: 'Чтобы продолжить, нужно согласие.',
  },
  privacy: 'Я согласен(на), чтобы 360°FACE обрабатывал мои данные для этой записи.',
  marketing: 'Хочу получать новости и предложения (необязательно).',
  reviewTitle: 'Подтвердите запись',
  total: 'Итого',
  confirm: 'Подтвердить запись',
  sending: 'Отправка…',
  paymentTitle: 'Как вам удобнее оплатить?',
  paymentSub: 'Оплата после процедуры. Сейчас ничего не списывается.',
  paymentLater: 'Решу позже',
  methods: {
    card_terminal: 'Карта',
    mbway: 'MB WAY',
    cash: 'Наличные',
    bank_transfer: 'Перевод',
    gift_card: 'Оплатить сертификатом',
    qr_transfer: 'QR-код',
  },
  doneTitle: (name: string) => `Спасибо, ${name}!`,
  doneBooked: 'Ваша запись подтверждена.',
  doneFuture: 'В день визита нажмите на этом экране «У меня есть запись». Тогда же выберете способ оплаты.',
  doneRequested: 'Заявка принята. Команда скоро подтвердит запись.',
  doneCheckedIn: 'Вы отметились. Присаживайтесь — мастер уже знает о вас.',
  doneNewCustomer: 'До встречи!',
  checkinTitle: 'Введите номер мобильного',
  checkinFind: 'Найти мою запись',
  scanOr: 'или',
  scanHint: 'Поднесите QR-код карты 360°FACE к сканеру',
  cardNoBooking: 'Записи на сегодня по этой карте не нашли. Введите номер телефона.',
  checkinMatches: 'Подтвердите вашу запись на сегодня',
  confirmBooking: 'Подтверждаю',
  checkinNone: 'На сегодня записей с этим номером не найдено.',
  checkinBook: 'Записаться сейчас',
  back: 'Назад',
  callStaff: 'Позвать сотрудника',
  loading: 'Загрузка…',
  newStart: 'Новая запись',
  errors: {
    CARD_NOT_FOUND: 'Карта не распознана. Введите номер телефона.',
    NETWORK: 'Нет подключения к интернету. Попробуйте чуть позже.',
    CRM_UNAVAILABLE: 'Система записи не отвечает. Попробуйте ещё раз или позовите сотрудника.',
    CRM_RATE_LIMITED: 'Слишком много запросов. Попробуйте чуть позже.',
    TOO_MANY_REQUESTS: 'Слишком много попыток. Подождите минуту или позовите сотрудника.',
    SLOT_TAKEN: 'Это время только что заняли. Выберите другое.',
    RECOGNITION_EXPIRED: 'Для безопасности подтвердите ваши данные ещё раз.',
    NO_TIME_FOR_ADDON: 'До следующей записи не хватает времени на эту доп. услугу.',
    VISIT_ALREADY_DONE: 'Эта запись уже завершена. Если нужна помощь, позовите администратора.',
    VISIT_NOT_EDITABLE: 'Этот визит здесь уже нельзя изменить. Позовите администратора, пожалуйста.',
    BOOKING_NOT_FOUND: 'Запись не найдена. Позовите сотрудника, пожалуйста.',
    VALIDATION_FAILED: 'Проверьте введённые данные.',
    PRODUCT_UNAVAILABLE: 'Этого товара больше нет в наличии.',
    UNKNOWN_GIFT: 'Этот сертификат недоступен. Позовите сотрудника, пожалуйста.',
    QUESTIONNAIRE_VERSION_MISMATCH: 'Анкета обновилась. Начните заново или позовите сотрудника.',
    QUESTIONNAIRE_INCOMPLETE: 'Ответьте на все вопросы.',
    default: 'Что-то пошло не так. Попробуйте ещё раз или позовите сотрудника.',
  },
  retry: 'Повторить',
};

const uk: Messages = {
  menuClassPass: 'ClassPass',
  menuClassPassSub: 'Я записаний(а) через ClassPass',
  cpTitle: 'Оберіть час вашого запису',
  cpNone: 'Найближчими годинами записів ClassPass немає.',
  cpNotFound: 'Не знайшли свій час?',
  cpChat: 'Якщо не знайшли свій запис, напишіть нам, будь ласка, у чат вашого застосунку ClassPass.',
  cpIsYou: (name: string) => `Ви — ${name}?`,
  cpYes: 'Так, це я',
  cpNo: 'Ні',
  cpAddonsTitle: 'Бажаєте щось додати до сеансу?',
  cpNoTime: 'Не вміщується до наступного запису',
  nifNote: '* Для рахунку (fatura) з NIF назвіть номер майстру або вкажіть його під час оплати.',
  countryTitle: 'Код країни',
  countrySearch: 'Пошук країни або коду',
  notFoundTitle: 'Запис не знайдено',
  notFoundText: 'Перевірте номер телефону та код країни.',
  notFoundAgain: 'Знову не знайшли. Працівник зараз допоможе.',
  tryAgain: 'Ввести ще раз',
  callAdmin: 'Покликати адміністратора',
  giftPhoneTitle: 'Ваш мобільний',
  giftPhoneSub: 'Щоб надіслати чек і звʼязатися за потреби.',
  buy: 'Купити',
  qTitle: 'Ви вже заповнювали нашу анкету клієнта?',
  qSub: 'Вона обовʼязкова перед будь-якою процедурою.',
  qYes: 'Так, заповнював(ла)',
  qNo: 'Ні, ще ні',
  qConfirm: 'Підтверджую, що заповнював(ла) анкету клієнта і мої дані про здоровʼя не змінилися.',
  qNeeded: 'Нічого страшного. Майстер дасть вам анкету перед процедурою.',
  qfOffer: 'Анкету можна заповнити просто зараз на екрані. Кілька коротких запитань про здоровʼя (близько 1 хвилини).',
  qfStart: 'Заповнити зараз',
  qfPaper: 'Краще паперову анкету',
  qfYes: 'Так',
  qfNo: 'Ні',
  qfDetailHint: 'Подробиці (необовʼязково)',
  qfName: 'Імʼя та прізвище',
  qfMissing: 'Дайте відповідь на всі запитання, вкажіть імʼя та дайте згоду.',
  qfSubmit: 'Надіслати майстру',
  qfCancel: 'Скасувати',
  qfPrivate: 'Відповіді надійно передаються вашому майстру і не зберігаються на цьому екрані.',
  qfDraft: 'Попередні запитання (на погодженні).',
  qfLoadError: 'Не вдалося відкрити анкету. Оберіть паперову анкету або покличте працівника.',
  qfStepAbout: 'Про вас',
  qfStepHealth: 'Здоровʼя',
  qfStepAesthetic: 'Естетичні процедури',
  qfStepSign: 'Підтвердження',
  qfBirth: 'Дата народження',
  qfBirthHint: 'ДД/ММ/РРРР',
  qfContact: 'Як зручніше з вами звʼязатися?',
  qfContactEmail: 'E-mail',
  qfContactWhatsapp: 'WhatsApp',
  qfContactTelegram: 'Telegram',
  qfContactPhone: 'Дзвінок',
  qfPressure: 'Інтенсивність масажу',
  qfPressureHint:
    '1 = дуже мʼяко, 3 = середньо, 5 = дуже інтенсивно. Уперше? Радимо 2–3. Можна змінити під час сеансу.',
  qfSimilar: 'Чи робили ви схожі процедури раніше?',
  qfHeard: 'Як ви про нас дізналися?',
  qfHeardInstagram: 'Instagram',
  qfHeardGoogle: 'Google',
  qfHeardFriend: 'Рекомендація',
  qfHeardClasspass: 'ClassPass',
  qfHeardTiktok: 'TikTok',
  qfHeardAi: 'ШІ-асистент (ChatGPT, Claude…)',
  qfHeardPassing: 'Проходив(ла) повз студію',
  qfHeardOther: 'Інше',
  qfHealthRead: 'Уважно прочитайте список:',
  qfNoneApply: 'Нічого з цього списку мене не стосується',
  qfSomeApply: 'У мене є щось зі списку',
  qfTickWhich: 'Позначте, що вас стосується. Майстер бачить це лише сьогодні.',
  qfNote: 'Коментар (необовʼязково)',
  qfAestheticWhat: 'Що, в якій зоні і коли?',
  qfSignHere: 'Розпишіться тут пальцем',
  qfClear: 'Стерти',
  qfNext: 'Далі',
  qfPrev: 'Назад',
  qfPageMissing: 'Заповніть позначені поля.',
  menuGift: 'Купити сертифікат',
  menuGiftSub: 'Готовий подарунок із собою',
  giftTitle: 'Подарунковий сертифікат',
  giftSub: 'Оберіть суму. Сертифікат діє на цю суму для будь-якої процедури.',
  giftHowTitle: 'Як ви хочете отримати сертифікат?',
  giftPickup: 'Забрати зараз у студії',
  giftPickupSub: 'Співробітник видасть конверт через 10–15 хвилин після оплати.',
  giftEmail: 'Отримати на e-mail',
  giftEmailSub: 'Ми передамо запит співробітнику; про оплату домовимося з вами поштою.',
  giftEmailField: 'Ваш e-mail',
  kbDone: 'Готово',
  kbSpace: 'пробіл',
  giftCardTitle: 'Для кого подарунок?',
  giftCardSub: 'Ці дані будуть на сертифікаті. Після надсилання ми напишемо вам на e-mail зі способами оплати.',
  giftTo: 'Кому (ім’я)',
  giftFrom: 'Від кого (ваше ім’я)',
  giftMessage: 'Побажання (необов’язково)',
  giftSend: 'Надіслати заявку',
  doneGiftEmail: (v: string) =>
    `Запит на сертифікат на ${v} прийнято. Наш співробітник напише вам, щоб домовитися про оплату та надіслати сертифікат.`,
  thanks: 'Дякуємо!',
  doneGift: (v: string) => `Співробітник видасть сертифікат на ${v} через 10–15 хвилин після оплати.`,
  languageTitle: 'Оберіть мову',
  productsTitle: 'Для дому',
  productsSub: 'Збережіть ефект процедури вдома. Необовʼязково.',
  productAdd: 'Додати',
  productAdded: 'Додано',
  productsSkip: 'Продовжити без покупок',
  productsNone: 'Зараз немає доступних товарів.',
  summaryTotal: 'Разом',
  presentTitle: 'Ваш подарунок',
  presentSub: (amount: string) => `При замовленні на ${amount} оберіть подарунок від студії.`,
  presentNone: 'Продовжити без подарунка',
  presentHint: (missing: string, gifts: string) => `Додайте ще ${missing} і оберіть подарунок: ${gifts}`,
  presentFrom: (amount: string) => `Від ${amount}`,
  presentLabel: 'Подарунок',
  presentFree: 'Безкоштовно',
  summaryExtras: (n: number) => `+${n} дод.`,
  summaryProducts: (n: number) => `товарів: ${n}`,
  callStaffDone: 'Ми покликали працівника. До вас скоро підійдуть.',
  tagline: 'Тренування обличчя руками наших майстрів. Без уколів.',
  chooseLanguage: 'Оберіть мову, щоб почати',
  bookThis: 'Записатися на процедуру',
  sourceNote: 'Опис і фото: 360face.pt',
  progress: ['Процедура', 'День і час', 'Доповнення', 'Дані', 'Підтвердження'],
  stepOf: (n: number, total: number) => `Крок ${n} з ${total}`,
  hourLabel: (h: string) => `${h}:00`,
  welcome: 'Ласкаво просимо до 360°FACE',
  welcomeSub: 'Торкніться екрана, щоб почати',
  menuTitle: 'Чим ми можемо допомогти?',
  menuBook: 'Записатися на процедуру',
  menuBookSub: 'Сьогодні або в інший день',
  menuCheckin: 'У мене є запис',
  menuCheckinSub: 'Відмітитися про прихід',
  chooseService: 'Оберіть процедуру',
  kinds: { face: 'Обличчя', body: 'Тіло', skin: 'Шкіра', combo: 'Комбо', addon: 'Доповнення' },
  minutes: 'хв',
  chooseDate: 'Оберіть день',
  chooseTime: 'Оберіть час',
  with: 'майстер',
  noSlots: 'Цього дня немає вільного часу. Оберіть інший день.',
  addonsTitle: 'Бажаєте щось додати?',
  addonsSub: 'Необовʼязково. Можна продовжити без доповнень.',
  continue: 'Продовжити',
  skip: 'Продовжити без доповнень',
  detailsTitle: 'Ваші дані',
  fields: {
    fullName: 'Імʼя та прізвище',
    phone: 'Мобільний телефон',
    email: 'Ел. пошта',
  },
  fieldErrors: {
    fullName: 'Вкажіть імʼя.',
    phone: 'Неправильний номер телефону.',
    email: 'Неправильна адреса ел. пошти.',
    privacy: 'Щоб продовжити, потрібна згода.',
  },
  privacy: 'Я погоджуюся, щоб 360°FACE обробляв мої дані для цього запису.',
  marketing: 'Хочу отримувати новини та пропозиції (необовʼязково).',
  reviewTitle: 'Підтвердіть запис',
  total: 'Разом',
  confirm: 'Підтвердити запис',
  sending: 'Надсилання…',
  paymentTitle: 'Як вам зручніше оплатити?',
  paymentSub: 'Оплата після процедури. Зараз нічого не списується.',
  paymentLater: 'Вирішу пізніше',
  methods: {
    card_terminal: 'Картка',
    mbway: 'MB WAY',
    cash: 'Готівка',
    bank_transfer: 'Переказ',
    gift_card: 'Оплатити сертифікатом',
    qr_transfer: 'QR-код',
  },
  doneTitle: (name: string) => `Дякуємо, ${name}!`,
  doneBooked: 'Ваш запис підтверджено.',
  doneFuture: 'У день візиту натисніть на цьому екрані «У мене є запис». Тоді ж оберете спосіб оплати.',
  doneRequested: 'Заявку прийнято. Команда невдовзі підтвердить запис.',
  doneCheckedIn: 'Ви відмітилися. Сідайте, будь ласка, — майстер уже знає про вас.',
  doneNewCustomer: 'До зустрічі!',
  checkinTitle: 'Введіть номер мобільного',
  checkinFind: 'Знайти мій запис',
  scanOr: 'або',
  scanHint: 'Піднесіть QR-код картки 360°FACE до сканера',
  cardNoBooking: 'Запису на сьогодні за цією карткою не знайшли. Введіть номер телефону.',
  checkinMatches: 'Підтвердіть ваш запис на сьогодні',
  confirmBooking: 'Підтверджую',
  checkinNone: 'На сьогодні записів із цим номером не знайдено.',
  checkinBook: 'Записатися зараз',
  back: 'Назад',
  callStaff: 'Покликати працівника',
  loading: 'Завантаження…',
  newStart: 'Новий запис',
  errors: {
    CARD_NOT_FOUND: 'Картку не розпізнано. Введіть номер телефону.',
    NETWORK: 'Немає підключення до інтернету. Спробуйте трохи згодом.',
    CRM_UNAVAILABLE: 'Система запису не відповідає. Спробуйте ще раз або покличте працівника.',
    CRM_RATE_LIMITED: 'Забагато запитів. Спробуйте трохи згодом.',
    TOO_MANY_REQUESTS: 'Забагато спроб. Зачекайте хвилину або покличте працівника.',
    SLOT_TAKEN: 'Цей час щойно зайняли. Оберіть інший.',
    RECOGNITION_EXPIRED: 'Для безпеки підтвердьте ваші дані ще раз.',
    NO_TIME_FOR_ADDON: 'До наступного запису не вистачає часу на цю додаткову послугу.',
    VISIT_ALREADY_DONE: 'Цей запис уже завершено. Якщо потрібна допомога, покличте адміністратора.',
    VISIT_NOT_EDITABLE: 'Цей візит тут уже не можна змінити. Покличте адміністратора, будь ласка.',
    BOOKING_NOT_FOUND: 'Запис не знайдено. Покличте працівника, будь ласка.',
    VALIDATION_FAILED: 'Перевірте введені дані.',
    PRODUCT_UNAVAILABLE: 'Цього товару більше немає в наявності.',
    UNKNOWN_GIFT: 'Цей сертифікат недоступний. Покличте працівника, будь ласка.',
    QUESTIONNAIRE_VERSION_MISMATCH: 'Анкету оновлено. Почніть знову або покличте працівника.',
    QUESTIONNAIRE_INCOMPLETE: 'Дайте відповідь на всі запитання.',
    default: 'Щось пішло не так. Спробуйте ще раз або покличте працівника.',
  },
  retry: 'Повторити',
};

const de: Messages = {
  menuClassPass: 'ClassPass',
  menuClassPassSub: 'Ich habe über ClassPass gebucht',
  cpTitle: 'Wählen Sie die Uhrzeit Ihrer Buchung',
  cpNone: 'In den nächsten Stunden gibt es keine ClassPass-Buchungen.',
  cpNotFound: 'Sie finden Ihre Uhrzeit nicht?',
  cpChat: 'Wenn Sie Ihre Buchung nicht finden, schreiben Sie uns bitte im Chat Ihrer ClassPass-App.',
  cpIsYou: (name: string) => `Sind Sie ${name}?`,
  cpYes: 'Ja, das bin ich',
  cpNo: 'Nein',
  cpAddonsTitle: 'Möchten Sie Ihrer Sitzung etwas hinzufügen?',
  cpNoTime: 'Passt nicht vor den nächsten Termin',
  nifNote: '* Für eine Rechnung mit Steuernummer (NIF) nennen Sie diese Ihrer Therapeutin oder beim Bezahlen.',
  countryTitle: 'Ländervorwahl',
  countrySearch: 'Land oder Vorwahl suchen',
  notFoundTitle: 'Termin nicht gefunden',
  notFoundText: 'Bitte prüfen Sie Ihre Handynummer und die Ländervorwahl.',
  notFoundAgain: 'Leider wieder nicht gefunden. Unser Team hilft Ihnen sofort.',
  tryAgain: 'Erneut versuchen',
  callAdmin: 'Team rufen',
  giftPhoneTitle: 'Ihre Handynummer',
  giftPhoneSub: 'Damit wir Ihnen den Beleg senden und Sie bei Bedarf kontaktieren können.',
  buy: 'Kaufen',
  qTitle: 'Haben Sie unseren Kundenbogen bereits ausgefüllt?',
  qSub: 'Er ist vor jeder Behandlung erforderlich.',
  qYes: 'Ja, bereits ausgefüllt',
  qNo: 'Nein, noch nicht',
  qConfirm:
    'Ich bestätige, dass ich den Kundenbogen ausgefüllt habe und sich meine Gesundheitsangaben nicht geändert haben.',
  qNeeded: 'Kein Problem. Ihre Therapeutin gibt Ihnen den Bogen vor der Behandlung.',
  qfOffer:
    'Sie können den Bogen jetzt hier am Bildschirm ausfüllen. Einige kurze Fragen zu Ihrer Gesundheit (ca. 1 Minute).',
  qfStart: 'Jetzt ausfüllen',
  qfPaper: 'Lieber auf Papier',
  qfYes: 'Ja',
  qfNo: 'Nein',
  qfDetailHint: 'Details (optional)',
  qfName: 'Vollständiger Name',
  qfMissing: 'Bitte beantworten Sie alle Fragen, geben Sie Ihren Namen an und erteilen Sie Ihre Einwilligung.',
  qfSubmit: 'An meine Therapeutin senden',
  qfCancel: 'Abbrechen',
  qfPrivate: 'Ihre Antworten gehen sicher an Ihre Therapeutin und werden auf diesem Bildschirm nicht gespeichert.',
  qfDraft: 'Vorläufige Fragen (in Prüfung).',
  qfLoadError: 'Der Bogen konnte nicht geöffnet werden. Wählen Sie den Papierbogen oder rufen Sie das Team.',
  qfStepAbout: 'Über Sie',
  qfStepHealth: 'Gesundheit',
  qfStepAesthetic: 'Ästhetische Behandlungen',
  qfStepSign: 'Bestätigung',
  qfBirth: 'Geburtsdatum',
  qfBirthHint: 'TT.MM.JJJJ',
  qfContact: 'Wie dürfen wir Sie kontaktieren?',
  qfContactEmail: 'E-Mail',
  qfContactWhatsapp: 'WhatsApp',
  qfContactTelegram: 'Telegram',
  qfContactPhone: 'Anruf',
  qfPressure: 'Massageintensität',
  qfPressureHint:
    '1 = sehr sanft, 3 = mittel, 5 = sehr intensiv. Beim ersten Mal empfehlen wir 2–3. Sie kann während der Sitzung angepasst werden.',
  qfSimilar: 'Hatten Sie schon ähnliche Behandlungen?',
  qfHeard: 'Wie haben Sie von uns erfahren?',
  qfHeardInstagram: 'Instagram',
  qfHeardGoogle: 'Google',
  qfHeardFriend: 'Empfehlung',
  qfHeardClasspass: 'ClassPass',
  qfHeardTiktok: 'TikTok',
  qfHeardAi: 'KI-Assistent (ChatGPT, Claude…)',
  qfHeardPassing: 'Am Studio vorbeigekommen',
  qfHeardOther: 'Sonstiges',
  qfHealthRead: 'Bitte lesen Sie die Liste aufmerksam:',
  qfNoneApply: 'Nichts auf dieser Liste trifft auf mich zu',
  qfSomeApply: 'Etwas auf dieser Liste trifft zu',
  qfTickWhich: 'Tippen Sie an, was zutrifft. Ihre Therapeutin sieht dies nur heute.',
  qfNote: 'Anmerkung (optional)',
  qfAestheticWhat: 'Was, in welchem Bereich und wann?',
  qfSignHere: 'Bitte hier mit dem Finger unterschreiben',
  qfClear: 'Löschen',
  qfNext: 'Weiter',
  qfPrev: 'Zurück',
  qfPageMissing: 'Bitte füllen Sie die markierten Felder aus.',
  menuGift: 'Gutschein kaufen',
  menuGiftSub: 'Ein Geschenk zum Mitnehmen',
  giftTitle: 'Geschenkgutschein',
  giftSub: 'Wählen Sie den Betrag. Der Gutschein gilt in dieser Höhe für jede Behandlung.',
  giftHowTitle: 'Wie möchten Sie den Gutschein erhalten?',
  giftPickup: 'Jetzt im Studio abholen',
  giftPickupSub: 'Das Team überreicht Ihnen den Umschlag nach der Zahlung in 10–15 Minuten.',
  giftEmail: 'Per E-Mail erhalten',
  giftEmailSub: 'Wir leiten die Anfrage an das Team weiter und klären die Zahlung per E-Mail mit Ihnen.',
  giftEmailField: 'Ihre E-Mail',
  kbDone: 'Fertig',
  kbSpace: 'Leerzeichen',
  giftCardTitle: 'Für wen ist das Geschenk?',
  giftCardSub:
    'Diese Angaben stehen auf dem Gutschein. Nach dem Absenden senden wir Ihnen die Zahlungsmöglichkeiten per E-Mail.',
  giftTo: 'Für (Name)',
  giftFrom: 'Von (Ihr Name)',
  giftMessage: 'Nachricht (optional)',
  giftSend: 'Anfrage senden',
  doneGiftEmail: (v: string) =>
    `Wir haben Ihre Anfrage für einen Gutschein über ${v} erhalten. Unser Team meldet sich per E-Mail, um die Zahlung zu klären und Ihnen den Gutschein zu senden.`,
  thanks: 'Vielen Dank!',
  doneGift: (v: string) => `Das Team überreicht Ihnen den Gutschein über ${v} nach der Zahlung in 10–15 Minuten.`,
  languageTitle: 'Sprache wählen',
  productsTitle: 'Für zu Hause',
  productsSub: 'Erhalten Sie die Wirkung Ihrer Behandlung zu Hause. Optional.',
  productAdd: 'Hinzufügen',
  productAdded: 'Hinzugefügt',
  productsSkip: 'Ohne Produkte fortfahren',
  productsNone: 'Derzeit sind keine Produkte verfügbar.',
  summaryTotal: 'Gesamt',
  presentTitle: 'Ihr Geschenk',
  presentSub: (amount: string) => `Ab ${amount} an Behandlungen wählen Sie ein Geschenk des Hauses.`,
  presentNone: 'Ohne Geschenk fortfahren',
  presentHint: (missing: string, gifts: string) => `Noch ${missing} mehr und Sie wählen ein Geschenk: ${gifts}`,
  presentFrom: (amount: string) => `Ab ${amount}`,
  presentLabel: 'Geschenk',
  presentFree: 'Gratis',
  summaryExtras: (n: number) => (n === 1 ? '+1 Extra' : `+${n} Extras`),
  summaryProducts: (n: number) => (n === 1 ? '1 Produkt' : `${n} Produkte`),
  callStaffDone: 'Unser Team wurde benachrichtigt. Gleich ist jemand bei Ihnen.',
  tagline: 'Gesichtstraining durch die Hände unserer Therapeutinnen. Ohne Nadeln.',
  chooseLanguage: 'Wählen Sie Ihre Sprache, um zu beginnen',
  bookThis: 'Diese Behandlung buchen',
  sourceNote: 'Beschreibung und Foto: 360face.pt',
  progress: ['Behandlung', 'Tag & Uhrzeit', 'Extras', 'Angaben', 'Bestätigen'],
  stepOf: (n: number, total: number) => `Schritt ${n} von ${total}`,
  hourLabel: (h: string) => `${h}:00`,
  welcome: 'Willkommen bei 360°FACE',
  welcomeSub: 'Zum Starten tippen',
  menuTitle: 'Wie können wir helfen?',
  menuBook: 'Behandlung buchen',
  menuBookSub: 'Heute oder an einem anderen Tag',
  menuCheckin: 'Ich habe einen Termin',
  menuCheckinSub: 'Einchecken',
  chooseService: 'Wählen Sie Ihre Behandlung',
  kinds: { face: 'Gesicht', body: 'Körper', skin: 'Haut', combo: 'Kombinationen', addon: 'Extras' },
  minutes: 'Min.',
  chooseDate: 'Tag wählen',
  chooseTime: 'Uhrzeit wählen',
  with: 'mit',
  noSlots: 'An diesem Tag sind keine Zeiten frei. Bitte wählen Sie einen anderen Tag.',
  addonsTitle: 'Möchten Sie etwas hinzufügen?',
  addonsSub: 'Optional. Sie können auch ohne Extras fortfahren.',
  continue: 'Weiter',
  skip: 'Ohne Extras fortfahren',
  detailsTitle: 'Ihre Angaben',
  fields: {
    fullName: 'Vor- und Nachname',
    phone: 'Handynummer',
    email: 'E-Mail',
  },
  fieldErrors: {
    fullName: 'Bitte geben Sie Ihren Namen ein.',
    phone: 'Ungültige Handynummer.',
    email: 'Ungültige E-Mail-Adresse.',
    privacy: 'Bitte stimmen Sie zu, um fortzufahren.',
  },
  privacy: 'Ich bin einverstanden, dass 360°FACE meine Daten zur Verwaltung dieses Termins verarbeitet.',
  marketing: 'Ich möchte Neuigkeiten und Angebote erhalten (optional).',
  reviewTitle: 'Termin bestätigen',
  total: 'Gesamt',
  confirm: 'Termin bestätigen',
  sending: 'Wird gesendet…',
  paymentTitle: 'Wie möchten Sie bezahlen?',
  paymentSub: 'Sie bezahlen nach der Behandlung. Jetzt wird nichts berechnet.',
  paymentLater: 'Später entscheiden',
  methods: {
    card_terminal: 'Karte',
    mbway: 'MB WAY',
    cash: 'Bar',
    bank_transfer: 'Überweisung',
    gift_card: 'Mit Gutschein bezahlen',
    qr_transfer: 'QR-Code',
  },
  doneTitle: (name: string) => `Vielen Dank, ${name}!`,
  doneBooked: 'Ihr Termin ist bestätigt.',
  doneFuture:
    'Tippen Sie am Tag Ihres Besuchs auf diesem Bildschirm auf „Ich habe einen Termin“. Dann wählen Sie auch die Zahlungsart.',
  doneRequested: 'Ihre Anfrage ist eingegangen. Unser Team bestätigt den Termin in Kürze.',
  doneCheckedIn: 'Sie sind eingecheckt. Bitte nehmen Sie Platz – Ihre Therapeutin ist bereits informiert.',
  doneNewCustomer: 'Bis bald!',
  checkinTitle: 'Geben Sie Ihre Handynummer ein',
  checkinFind: 'Termin suchen',
  scanOr: 'oder',
  scanHint: 'Halten Sie den QR-Code Ihrer 360°FACE-Karte an den Scanner',
  cardNoBooking: 'Für diese Karte haben wir heute keinen Termin gefunden. Bitte geben Sie Ihre Handynummer ein.',
  checkinMatches: 'Bestätigen Sie Ihren heutigen Termin',
  confirmBooking: 'Ich bestätige',
  checkinNone: 'Für diese Nummer haben wir heute keinen Termin gefunden.',
  checkinBook: 'Jetzt buchen',
  back: 'Zurück',
  callStaff: 'Team rufen',
  loading: 'Wird geladen…',
  newStart: 'Neue Buchung',
  errors: {
    CARD_NOT_FOUND: 'Karte nicht erkannt. Bitte geben Sie Ihre Handynummer ein.',
    NETWORK: 'Keine Internetverbindung. Bitte versuchen Sie es gleich noch einmal.',
    CRM_UNAVAILABLE: 'Das Buchungssystem antwortet nicht. Versuchen Sie es erneut oder rufen Sie das Team.',
    CRM_RATE_LIMITED: 'Zu viele Anfragen gleichzeitig. Bitte versuchen Sie es gleich noch einmal.',
    TOO_MANY_REQUESTS: 'Zu viele Versuche. Warten Sie eine Minute oder rufen Sie das Team.',
    SLOT_TAKEN: 'Diese Uhrzeit wurde gerade vergeben. Bitte wählen Sie eine andere.',
    RECOGNITION_EXPIRED: 'Zu Ihrer Sicherheit bestätigen Sie Ihre Angaben bitte noch einmal.',
    NO_TIME_FOR_ADDON: 'Heute reicht die Zeit vor dem nächsten Termin nicht mehr für dieses Extra.',
    VISIT_ALREADY_DONE: 'Dieser Termin ist bereits abgeschlossen. Wenn Sie Hilfe brauchen, rufen Sie bitte das Team.',
    VISIT_NOT_EDITABLE: 'Dieser Besuch kann hier nicht mehr geändert werden. Bitte rufen Sie das Team.',
    BOOKING_NOT_FOUND: 'Wir konnten diesen Termin nicht finden. Bitte rufen Sie das Team.',
    VALIDATION_FAILED: 'Bitte prüfen Sie Ihre Angaben.',
    PRODUCT_UNAVAILABLE: 'Dieses Produkt ist nicht mehr verfügbar.',
    UNKNOWN_GIFT: 'Dieser Gutschein ist nicht verfügbar. Bitte rufen Sie das Team.',
    QUESTIONNAIRE_VERSION_MISMATCH: 'Der Bogen wurde aktualisiert. Bitte beginnen Sie neu oder rufen Sie das Team.',
    QUESTIONNAIRE_INCOMPLETE: 'Bitte beantworten Sie alle Fragen.',
    default: 'Etwas ist schiefgelaufen. Versuchen Sie es erneut oder rufen Sie das Team.',
  },
  retry: 'Erneut versuchen',
};

export const MESSAGES: Record<Locale, Messages> = { pt, en, fr, es, ru, uk, de };

export function errorText(m: Messages, code: string): string {
  return (m.errors as Record<string, string>)[code] ?? m.errors.default;
}
